import clsx from 'clsx'
import React, { useContext, useState } from 'react'

import { HeadlessListbox } from 'slab/components/HeadlessListbox'

import { AutocompleteContext } from './context'

interface AutocompleteOptionProps extends React.ComponentProps<typeof HeadlessListbox.Option> {
  children: React.ReactNode;
  disabled?: boolean;
  redactedFromPosthog?: boolean;
  value?: string | null;
}

export function AutocompleteOption ({ children, disabled, onSelect: onSelectProp, redactedFromPosthog, value, ...props }: AutocompleteOptionProps) {
  const { onSelect } = useContext(AutocompleteContext)
  const [isPending, setPending] = useState(false)

  return (
    <HeadlessListbox.Option
      {...props}
      className='py-1 px-2 group/option outline-none scroll-my-1'
      disabled={isPending || disabled}
      onMouseDown={(event) => {
        // Prevent focus from moving to the option on click
        event.preventDefault()
        props.onMouseDown?.(event)
      }}
      onSelect={async (value) => {
        setPending(true)
        const result = await onSelectProp?.(value)
        setPending(false)

        onSelect(value, { closeAfterSelection: result !== false })
      }}
      value={value}
    >
      <div
        data-testid='autocomplete-option-wrapper'
        className={clsx(
          'p-2 rounded-md bg-transparent flex gap-4 items-center body',
          'cursor-pointer group-data-[disabled]/option:cursor-default group-data-[disabled]/option:text-gray-800/40',
          'text-gray-800 group-data-[selected]/option:bg-gray-100',
          redactedFromPosthog && 'ph-no-capture'
        )}
      >

        {children}
      </div>
    </HeadlessListbox.Option>
  )
}

AutocompleteOption.displayName = 'Autocomplete.Option'
